import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Color } from "../../../../../utils/theme";
import { cleannerError } from "../../../../../utils/utils";
import { SocialMediaFormData } from "../../../../../utils/api/config/config.type";
import { useUpdateSocialMediaMutation } from "../../../../../utils/api/config/config.api";
import { QueryError } from "../../../../../utils/type";

function useSocialMediaForm() {
	const validationSchema = yup.object().shape({
		facebook: yup.string().url().label("Facebook"),
		instagram: yup.string().url().label("Instagram"),
		linkedin: yup.string().url().label("Linkedin"),
		twitter: yup.string().url().label("Twitter"),
		email: yup.string().email().required().label("Email"),
		adresse: yup.string().required().label("Adresse"),
		telephone: yup.string().required().label("Telephone"),
	});

	const {
		register,
		handleSubmit,
		formState: { errors },
		setValue,
		clearErrors,
	} = useForm<SocialMediaFormData>({
		resolver: yupResolver(validationSchema),
	});

	const [updateSocialMedia, { isLoading, isSuccess, error, isError }] =
		useUpdateSocialMediaMutation();

		const [phone, setPhone] = useState<string>();

		const onChangePhone = (phone: string) => {
			setPhone(phone);
			setValue("telephone", `+${phone}`);
		};

		const handleChangeAdress = (value) => {
			setValue("adresse", value?.rue);
		};
	useEffect(() => {
		if (isSuccess) {
			Swal.fire({
				icon: "success",
				title: `Modifié avec succès`,
				iconColor: Color.success,
				showConfirmButton: false,
				timer: 2000,
			});
		}
		const err = error as QueryError;
		if (isError) {
			Swal.fire({
				icon: "error",
				title: err?.data?.message ? err?.data?.message : "Une erreur a survenu",
				showConfirmButton: false,
				timer: 5000,
			});
		}
	}, [isLoading]);

	useEffect(() => {
		cleannerError(errors, clearErrors);
	}, [errors]);

	const onSubmit = (data: SocialMediaFormData) => {
		console.log(data);
		updateSocialMedia({ slug: data?.slug, data });
	};

	return {
		register,
		errors: errors,
		onSubmit: handleSubmit(onSubmit),
		setValue,
		isLoading: isLoading,
		phone,
		onChangePhone,
		setPhone,
		handleChangeAdress,
	};
}
export default useSocialMediaForm;
